import { ViewRequest, MeasureRequest, DataFormat, EntityRequest, FilterType } from '../graphql/generated/graphql';
import { Filter, FragmentConfig } from '../fragments/types';

import { isSeries } from '../fragments/getFragmentByType';
const getMeasuresFromConfig = (measures: MeasureRequest[]): any => {
  return measures.map((measure) => {
    const { ignore = FilterType.None, measureName, filters } = measure;
    return {
      ignore,
      measureName,
      filters,
    };
  });
};

// Todo: To be refactored or cleaned up during the multiple visualisations
// const getMeasuresFromVisualisationsConfig = (visualisations: Visualisation[], requestType: RequestType): any => {
//   const visualisation = visualisations.find((item) => item.type === requestType);
//   if (!visualisation) {
//     throw new Error(`Missing visualisation for ${requestType}`);
//   }
//   return getMeasuresFromConfig(visualisations[0].measures);
// };

interface CreateGraphqlRequestParams {
  config: FragmentConfig;
  pageNumber?: number;
  pageSize?: number;
  selectedEntity?: string;
  filters?: Filter;
  isBenchmark?: boolean;
}
export function createGraphQlRequest({
  config,
  pageNumber = 1,
  pageSize = 1,
  selectedEntity,
  filters = {},
  isBenchmark = false,
}: CreateGraphqlRequestParams): ViewRequest {
  const pageFilters = { ...config.filters, ...filters };

  const baseEntity = {
    entity: 'all',
    filters: {},
  };

  const entities: EntityRequest[] = config.entities.map((entity) => {
    const sortBy =
      typeof entity.sortBy !== 'object'
        ? { measureName: entity.sortBy || '' }
        : { measureName: entity.sortBy.measureName, filters: entity.sortBy.filters };
    return {
      entity:
        selectedEntity && entity.alternativeEntities && entity.alternativeEntities.includes(selectedEntity)
          ? selectedEntity
          : entity.entity,
      selection: entity.selection,
      sortBy,
      pageNumber,
      limit: pageSize === 1 ? entity.limit : pageSize,
      filters: entity.filters,
      name: entity.name,
      entityIds: entity.entityIds,
    };
  });

  const SubTitleMeasures = config.subTitle ? getMeasuresFromConfig(config.subTitle) : [];
  const fragmentType = config.visualisations[0].type;
  const measuresFromConfig = ['overview', 'summary'].includes(fragmentType)
    ? [...SubTitleMeasures, ...config.visualisations[0].measures]
    : config.visualisations[0].measures;
  const measures = measuresFromConfig.map((measure) => ({
    measureName: measure.measureName,
    filters: measure.filters,
    ignore: measure.ignore,
  }));
  const dataFormat =
    (config?.dataFormat as DataFormat) ?? (isSeries(fragmentType) ? DataFormat.Series : DataFormat.Single);

  return {
    measures,
    entities: isBenchmark ? [baseEntity, ...entities] : entities,
    scope: config.scope,
    dataFormat,
    pageFilters,
  };
}
